export default __webpack_public_path__ + "static/media/placement-class-finish.96420e4b.svg";